export class Document {
	id;
	slug;
	title;
	date;
	
	image;
	description;

	exhibitions;
	
	constructor (object)
	{
		// Info
		this.id = object.id || null;
		this.slug = object.slug || null;
		this.title = object.title.rendered || null;
		this.date = object.date || null;

		// Content
		this.content = object.meta_box.content.content || null;
		this.file = object.meta_box.content.file || null;
		
		// Image
		this.image = object.meta_box.content.image || null;
		
		// Relations
		this.exhibitions = object.meta_box.news_to_exhibitions_to || [];
	}
}


// WEBPACK FOOTER //
// ./src/data/classes/document.class.js